export default "__VITE_ASSET__ByreWD7V__"